import './article.css';

import sanqciebi from '../../../photos/Article/sanqciebi.png';
import skamerebi from '../../../photos/Article/skamerebi.png';
import xmebi from '../../../photos/Article/xmebi.jpg';

// import { SeeAllButton } from '../../../components/seeallbutton/SeeAll';

const articleList = [
    { src: sanqciebi, title: "Read More", link: "https://transparency.ge/ge/post/kartuli-ocnebis-dasankcirebuli-carmomadgenlebi/?custom_searched" },
    { src: skamerebi, title: "Read More", link: "https://ifact.ge/gaitsanit-skameri/" },
    { src: xmebi, title: "Read More", link: "https://monitori.ge/ra-daujdat-erti-saarchevno-khma-da-rashi-dakharjes-fuli-partiebma-saarchevnod/" },
]

export function Article() {
    return (
        <div className="article-zipotela">
            <div className="article div">
                <h4 className="article-title title">Articles</h4>
                <div className="article-content content">
                    {
                        articleList.map((articleLists, index) => (
                            <div className="article-lists lists">
                                <div className="article-img lists-img-div">
                                    <img src={articleLists.src} alt="logo" />
                                </div>
                                <div className='article-list-title lists-title'>
                                    <h4>
                                        <a href={articleLists.link} target="_blank" rel="noopener noreferrer">
                                            {articleLists.title} &#8811;
                                        </a>
                                    </h4>
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>
        </div>

    )
}